import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { SimulationCopy } from 'src/app/features/setup/models/simulation';
import { Observable } from 'rxjs';
import {
  NewBrandCategorySaveResponse,
  NewPackSaveResponse,
  PvpBaseline,
  PvpBaselineCategoryDetail,
  PvpBaselineChannelDetail,
  PvpBaselinePackDetail
} from '../models/pvp-import.model';

@Injectable({
  providedIn: 'root'
})
export class SetupService {

  constructor(private http: HttpClient) { }
  apiUrl = environment.champsApiUrl;

  getUserInformation() {
    const userInfo =
    {
      dateFormat: environment.dateFormat
    };
    return userInfo;

  }
  GetAllUsers() {
    return this.http.get<any>(`${this.apiUrl}/Account/GetUser`);
  }
  GetUserList() {
    return this.http.get<any>(`${this.apiUrl}/Account/GetUser`);
  }

  GetAllUserTenant() {
    return this.http.get<any>(`${this.apiUrl}/Account/GetUserAccess`);
  }

  GetAllTenants() {
    return this.http.get<any>(`${this.apiUrl}/Tenant/GetAllTenant`);
  }
  // tslint:disable-next-line: typedef
  GetTenantList(userId: string) {
    const params = new HttpParams()
      .set('userId', `${userId}`);
    return this.http.get<any>(`${this.apiUrl}/DropDown/Tenant`, { params });
  }
  // tslint:disable-next-line: typedef
  getAllUserBaselines(userId: string, tenantId: number = 0, baselineId: number = 0) {
    const params = new HttpParams()
      .set('userId', `${userId}`)
      .set('tenantId', `${tenantId}`)
      .set('baselineId', `${baselineId}`)
    return this.http.get<any>(`${this.apiUrl}/BaseLine/GetByUserTenant`, { params });
  }

  isBaselineNameExists(baseLineName: string) {
    const params = new HttpParams()
      .set('baseLineName', `${baseLineName}`)
    return this.http.get<any>(`${this.apiUrl}/BaseLine/GetByName`, { params });
  }

  getAllTenants(userId: string, tenantId: number) {
    const params = new HttpParams()
      .set('userId', `${userId}`)
      .set('tenantId', `${tenantId}`)
    return this.http.get<any>(`${this.apiUrl}/Tenant/GetByUserTenant`, { params });
  }

  postBaseLineSave(PackageFormBody: object): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/BaseLine/Save`, PackageFormBody);
  }


  lockUnlockBaseline(obj): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/BaseLine/BaselineLockUnlock`, obj);
  }

  removeBaseLine(baselineId: number, userId: string): Observable<any> {
    const params = new HttpParams()
      .set('baselineId', `${baselineId}`)
      .set('userId', `${userId}`)
    return this.http.delete<any>(`${this.apiUrl}/BaseLine/remove`, { params });
  }

  //////////////////////////////
  getAllUserSimulations(userId: string) {
    const params = new HttpParams()
      .set('userId', `${userId}`)
    // .set('tenantId', `${tenantId}`);
    return this.http.get<any>(`${this.apiUrl}/Simulation/GetSimulation`, { params });
  }

  postSimulationCopy(sim: SimulationCopy) {
    console.log(sim);
    return this.http.post(`${this.apiUrl}/Simulation/SaveSimulation`, sim
    );
  }

  removeSimulation(id: number, userName: string | null) {
    const params = new HttpParams()
      .set('simulationId', `${id}`)
      .set('userId', `${userName}`);
    return this.http.delete(`${this.apiUrl}/Simulation/remove`, { params });
  }

  //#region PvP Import.
  getPvpBaselineList(baselineId: number, tenantId: number, userId: string): Observable<PvpBaseline[]> {
    const params = new HttpParams()
      .set('baselineId', `${baselineId}`)
      .set('tenantId', `${tenantId}`)
      .set('userId', userId);
    return this.http.get<PvpBaseline[]>(`${this.apiUrl}/Setup/GetPvpBaselineList`, { params });
  }

  saveSelectedPvpBaseline(selectedPvpBaselineSaveRequest: object): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/Setup/SavePVPBaselineSelect`, selectedPvpBaselineSaveRequest
    );
  }

  savePvpBaselineConfigration(selectedPvpBaselineSaveRequest: object): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/Setup/SavePVPBaselineSelect`, selectedPvpBaselineSaveRequest
    );
  }

  getPvpBaselineChannelDetails(selectedPvpBaselineId: number): Observable<PvpBaselineChannelDetail[]> {
    const params = new HttpParams()
      .set('pvpBaselineId', `${selectedPvpBaselineId}`);
    return this.http.get<PvpBaselineChannelDetail[]>(`${this.apiUrl}/Setup/GetPvpBaselineChannelDetails`, { params });
  }

  savePvpBaselineChannel(pvpChannelSaveRequest: object): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/Setup/SavePVPBaselineChannel`, pvpChannelSaveRequest
    );
  }

  getPvpBaselineCategoryDetails(selectedPvpBaselineId: number): Observable<PvpBaselineCategoryDetail[]> {
    const params = new HttpParams()
      .set('pvpBaselineId', `${selectedPvpBaselineId}`);
    return this.http.get<PvpBaselineCategoryDetail[]>(`${this.apiUrl}/Setup/GetPvpBaselineCategoryDetails`, { params });
  }

  savePvpNewBrandCategory(newBrandCategorySaveRequest: object): Observable<NewBrandCategorySaveResponse[]> {
    return this.http.post<NewBrandCategorySaveResponse[]>(
      `${this.apiUrl}/Setup/SavePVPBaselineCategory`, newBrandCategorySaveRequest
    );
  }

  getPvpBaselinePackDetails(selectedPvpBaselineId: number): Observable<PvpBaselinePackDetail[]> {
    const params = new HttpParams()
      .set('pvpBaselineId', `${selectedPvpBaselineId}`);
    return this.http.get<PvpBaselinePackDetail[]>(`${this.apiUrl}/Setup/GetPvpBaselinePackDetails`, { params });
  }

  savePvpNewPack(newPackSaveRequest: object): Observable<NewPackSaveResponse[]> {
    return this.http.post<NewPackSaveResponse[]>(
      `${this.apiUrl}/Setup/SavePVPBaselinePack`, newPackSaveRequest
    );
  }

  pvpBaselineImportAtFinalStep(pvpBaselineImportRequest: object): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/Setup/SavePVPBaseline`, pvpBaselineImportRequest
    );
  }

  uploadExcelFile(formData: FormData): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/Setup/UploadExcel`, formData
    );
  }

  saveExcelFileData(selectedExcelSheetData: object): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/Setup/SaveExcelFileData`, selectedExcelSheetData
    );
  }

  saveUser(userObj)
  {
    return this.http.post<any>(
      `${this.apiUrl}/Account/SaveUser`, userObj
    );
  }
  saveTenant(tenantObj){
    return this.http.post<any>(
      `${this.apiUrl}/Tenant/SaveTenant`, tenantObj
    );
  }
  saveUserAccess(userTenantObj){
    return this.http.post<any>(
      `${this.apiUrl}/Account/SaveUserAccess`, userTenantObj
    );
  }
  //#endregion Pvp Import.
}
